import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { ClientGroupDto } from "@/core/features/client-groups/client-group.dto";
import { ClientPaymentMethodDto } from "@/core/features/client-payment-methods/client-payment-method.dto";
import { ClientConditionCodeDto } from "@/core/features/client-condition-codes/client-condition-code.dto";
import { BankDto } from "@/core/features/banks/bank.dto";
import { Type } from "class-transformer";
import { ClientLineEnum } from "@altertec_gparn/lib";

export class ClientDto extends BaseEntityDto {
  name: string;

  vatNumber?: string;

  sapCode?: string;

  address?: string;

  country?: string;

  line: ClientLineEnum;

  @Type(() => BankDto)
  bank?: BankDto;
  bankId?: string;

  @Type(() => ClientGroupDto)
  clientGroup: ClientGroupDto;
  clientGroupId: string;

  @Type(() => ClientPaymentMethodDto)
  clientPaymentMethod?: ClientPaymentMethodDto;
  clientPaymentMethodId?: string;

  @Type(() => ClientConditionCodeDto)
  clientConditionCode?: ClientConditionCodeDto;
  clientConditionCodeId?: string;

  vatType?: number;

  withholding?: number;

  toString() {
    return this.name;
  }
}
